import React, { useState, useEffect } from 'react';
import Modal from './modal';
import bnbabi from "../../abis/bnbabi.json";
import Modalwallet from "../../components/wallet/modalwallet";
const Web3 = require('web3-eth');

//let uri = []

let meta = '15000' + "0".repeat(18)
const Private = (props) => {
  let pprovider = props.p;
  let accounts = props.acc;

  const web3 = new Web3(pprovider);
  const [hubtx, sethubtx] = useState(false);
  const [Raised, st] = useState('0')
  const [RaisedT, stT] = useState('0')
  let stakesabi = [
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "_buy",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "remove",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_contractm",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "own",
          "type": "address"
        }
      ],
      "stateMutability": "payable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "_contract",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "_owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BUSD",
      "outputs": [
        {
          "internalType": "contract IBEP20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "raised",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "raisedT",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "router",
      "outputs": [
        {
          "internalType": "contract Router",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "WBNB",
      "outputs": [
        {
          "internalType": "contract IBEP20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ]

  const [uri, seturi] = useState([]);
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {

  }, []);


  function setRaised(e) {
    st((5000 + parseFloat(nextblock(e, 18))).toString())
  }
  function setRaisedT(e) {
    stT(nextblock(e, 18))
  }
  function nextblock(accountBalancemctTB, d) {
    let a = accountBalancemctTB.toString().length >= d
      ? accountBalancemctTB.toString().slice(0, accountBalancemctTB.toString().length - d) + '.' + accountBalancemctTB.toString().slice(accountBalancemctTB.toString().length - d, accountBalancemctTB.toString().length)
      : '0.' + '0'.repeat(d - accountBalancemctTB.toString().length) + accountBalancemctTB
    if ((a).toString().includes('.')) {
      if (accountBalancemctTB.toString().length >= d) {
        return (
          (a).toString().split('.')[0] +
          '.' +
          (a).toString().split('.')[1].slice(0, 2)
        );
      } else {
        return a
      }
    } else {
      return a;
    }
  }

  const SAFE = (props) => {
    return (
      <p style={{ width: "100%", display: "grid", gridTemplateColumns: "auto auto" }}><span style={{
        textAlign: "left",
        width: "100%",
        fontWeight: "bold",
        color: "#e5e5e5",
        fontSize: "12px"
      }}>{props.what} </span><span style={{
        textAlign: "right",
        width: "100%",
        fontSize: "13px",
        color: props.resultc
      }}>
          {props.result}
        </span></p>
    );
  }


  function Menustyle() {
    return <div style={{
      height: "70px",
      width: "100%",
      margin: "auto",
      overflow: "hidden",
      display: "grid",
      gridTemplateColumns: "80px auto 150px",

    }}>
      <div style={{
        height: "70px",
        width: "70px",
        color: "#fff",
        margin: "auto",
        background: "url(" + "favicon.ico" + ")",
        backgroundSize: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        display: "grid",
        borderRadius: "360px",
      }}>

      </div>
      <p></p>
      <div style={{
        border: "1px solid #ffffff40",
        borderRadius: "5px", cursor: "pointer", height: "35px", width: "140px", display: "grid", margin: "auto"
      }} onClick={() => {
        sethubtx(true);
      }}>
        <h1 style={{ fontSize: "16px", margin: "auto" }}>{props.buttoconect()}</h1>
      </div>
    </div>
  }

  function setProgress(progress) {
    return "conic-gradient(#03ff18 " +
      progress +
      "%,#1b1b1b " +
      progress +
      "%)";
  }
  function showProgress(progress) {

    return progress.toString().includes('.') ? progress.toString().split('.')[0] + "%" : progress.toString() + "%";
  }
  let titlessss = <div style={{
    height: "min-content",
    minHeight: "240px",
    width: "100%",
    display: "grid",

    borderRadius: "2px",
    margin: "auto",
    color: "#fff"
  }}>

    <div style={{
      height: "min-content",
      minHeight: "380px",
      width: "95%",
      display: "grid",
      margin: "auto",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr)",
      gap: "10px",
    }}>

    {false &&  <div style={{
        height: "min-content",
        minHeight: "380px",
        width: "280px",
        display: "grid",
        margin: "auto",
        color: "#fff",
        borderRadius: "10px",
        fontSize: "16px",

      }}>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div id="progress-spinner" style={{ background: setProgress((parseFloat(Raised) * 100) / parseFloat(nextblock(meta, 18))) }} />
          <div id="middle-circle">
            <p style={{ color: "#fff", fontSize: "60px" }}>{showProgress((parseFloat(Raised) * 100) / parseFloat(nextblock(meta, 18)))}</p>
          </div>
        </div>
      </div>}


      <div style={{
        height: "380px",
        width: "280px",
        display: "grid",
        margin: "0 auto",
        gap:"1px",
        border: "1px solid #26323850",
        background: "#26323840",
        color: "#fff",
        borderRadius: "10px",
        fontSize: "15px"
      }}>
        {hubtx && <Modalwallet
          updateModals={(e) => { sethubtx(!hubtx) }}
          Disconnect={props.Disconnect}
          connecttometamask={props.connecttometamask}
          sethubtx={sethubtx}
          connecttowalletconnect={props.connecttowalletconnect}
        />}
        {<Menustyle />}
        {<Modal heighti={"50px"} bgcolor={"#1e1f2680"} buttoncolor={"#00000050"} setRaised={setRaised} setRaisedT={setRaisedT} array={[pprovider, '0x47e497e988A792D16d649DfCfFcc216910DfaBBA', stakesabi, "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", bnbabi, accounts]} />}
        <div style={{
          width: "260px",
          display: "grid",
          margin: "0 auto",

          color: "#fff",
          borderRadius: "10px",
          fontSize: "15px",
          padding: "1vh"
        }}>
          <SAFE what={"Private Address"} result={('0x47e497e988A792D16d649DfCfFcc216910DfaBBA').slice(0, 4) + "..." + ('0x47e497e988A792D16d649DfCfFcc216910DfaBBA').slice(-4)} />
          <SAFE what={"Start Time"} result={"2023.01.10 18:00 (UTC)"} />
          <SAFE what={"End Time"} result={'2023.02.9 03:00 (UTC)'} />
          <SAFE what={"Raised"} result={Raised + "USD"} />
          <SAFE what={"Meta"} result={"15000 USD"} />
          {false && <SAFE what={"Min Buy"} result={"0 USD"} />}
          {false && <SAFE what={"Max Buy"} result={"15000 USD"} />}
          {false && <SAFE what={"Your contribution"} result={"0 BNB"} />}
        </div>

      </div>
    </div>
  </div>
  return (
    <div className="farms">

      {titlessss}

    </div>
  );
}

export default Private;